<script>
  import options from './FormInputDateField.options'
  export default options
</script>

<template>
  <div class="Form__Element FormTextbox" :class="{ValidationRequired: isRequired}">
      <label :for="fieldName" class="Form__Element__Caption" >
          {{ label }}

      </label>

      <template v-if="tooltipText">
          <TooltipComponent :tooltipText="tooltipText" />
      </template>

      <input class="FormTextbox__Input"
          :min="minDate"
          :disabled="disabled ? disabled : readOnly" 
          :value="modelValue" 
          :autocomplete="autocomplete"
          @input="$emit('update:modelValue', $event.target.value)"
          :class="{'validation-error': isValidationError}"
          :id="fieldName" 
          type="date"
          :required="isRequired ? true : false"
          :aria-describedby="`${fieldName}__desc`" 
          :aria-invalid="isValidationError"
          :placeholder="placeholder"
          :maxlength="maxlength"
          @change="onChangeCallback"
          />

          <p class="kb-form__input-helptext" v-if="helpMessageLabel" >
              {{ helpMessageLabel }}
          </p>

          <div aria-live="assertive">
              <p class="kb-forms Form__Element__ValidationError" role="alert" v-if="isValidationError">
                  {{ errorMessageLabel }}
              </p>
          </div>
  </div>
</template>
